@if ({
  request: request$ | async,
  }; as content) {
  <table class="table-responsive table-md m-t-20">
    <thead>
      <tr>
        <th>{{ 'productChanges.product' | cxTranslate }}</th>
        <th>{{ 'productChanges.maxQuantity' | cxTranslate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (entry of content?.request?.productChanges; track entry) {
        <tr>
          <td>
            <span class="responsive-title">{{ 'productChanges.product' | cxTranslate }}: </span>
            {{ entry.product.name }}
          </td>
          <td>
            <span class="responsive-title">{{ 'productChanges.maxQuantity' | cxTranslate }}: </span>
            {{ entry.quantityAllowed }}
          </td>
        </tr>
      }
    </tbody>
  </table>
}